var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhantomIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54988 26C7.37819 26 10.2552 22.5349 11.9721 19.7968C11.7633 20.4026 11.6473 21.0083 11.6473 21.59C11.6473 23.1892 12.529 24.3281 14.2691 24.3281C16.6589 24.3281 19.2111 22.1472 20.5336 19.7968C20.4408 20.1361 20.3944 20.4511 20.3944 20.7418C20.3944 21.8565 20.9977 22.5592 22.2273 22.5592C26.1021 22.5592 30 15.411 30 9.15937C30 4.28891 27.6334 0 21.6938 0C11.2528 0 0 13.2787 0 21.8565C0 25.2246 1.74013 26 3.54988 26ZM18.0974 8.62628C18.0974 7.41472 18.747 6.56664 19.6984 6.56664C20.6264 6.56664 21.2761 7.41472 21.2761 8.62628C21.2761 9.83784 20.6264 10.7102 19.6984 10.7102C18.747 10.7102 18.0974 9.83784 18.0974 8.62628ZM23.0627 8.62628C23.0627 7.41472 23.7123 6.56664 24.6636 6.56664C25.5916 6.56664 26.2412 7.41472 26.2412 8.62628C26.2412 9.83784 25.5916 10.7102 24.6636 10.7102C23.7123 10.7102 23.0627 9.83784 23.0627 8.62628Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantomIconNew);
export default __webpack_public_path__ + "static/media/Phantom-icon-new.a4e089466ad1a9e4fb9abbb021e46e95.svg";
export { ForwardRef as ReactComponent };